import apiClient from './apiClient';
import { CreateCommentRequest } from '@/types/comment';
import { CreateCommentResponse } from '@/types/api';
import { appDataStore } from '@/services/cache/appDataStore';

export const commentsApi = {
  async createComment(
    songId: number,
    data: CreateCommentRequest
  ): Promise<CreateCommentResponse> {
    // Post to API
    const response = await apiClient.post(`/songs/${songId}/comments`, data);

    // Update cache with new comment
    if (response.data.comment) {
      appDataStore.addComment(songId, response.data.comment);
    }

    return response.data;
  },
};
